import Vue from 'vue'
import Vuex from 'vuex'
import { alarmStore } from './alarm'
import { authStore } from './auth'
import { companyStore } from './company'
import { errorStore } from './error'
import { lineStore } from './line'
import { machineStore } from './machine'
import { sensorStore } from './sensor'
import { warningStore } from './warning'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    company: companyStore,
    sensor: sensorStore,
    machine: machineStore,
    line: lineStore,
    auth: authStore,
    error: errorStore,
    alarm: alarmStore,
    warning: warningStore
  }
})
